import useInitBroadcast from 'modules/overlay-v2/ui/hooks/initializers/use-init-broadcast';
import useInitDataOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-data-overlay-v2';
import useInitSubscribeOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-subscribe-overlay-v2';
import { useParsePopupMessage } from 'modules/overlay-v2/ui/hooks/use-parse-popup-message';

function useInitOverlay() {
  useInitBroadcast();
  useInitDataOverlayV2();
  useInitSubscribeOverlayV2();
  // Окно оверлея, открытое кнопкой «Открыть окно» на панели управления, принимает от неё
  // команды: счёт, фолы, тайм, смена табло, полная синхронизация. Без этого слушателя
  // панель отправляет `postMessage` в пустоту, и окно живёт только на данных из трансляции.
  useParsePopupMessage();
}

export default useInitOverlay;
